/// <reference types="datatables.net" />

import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from "@angular/router";
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ScanQrCodeComponent } from '../../admin-container/scan-qr-code/scan-qr-code.component';
import { NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { Location } from '@angular/common';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { Contacts } from '../../_models/contacts';

@Component({
  selector: 'app-view-orders',
  templateUrl: './view-orders.component.html',
  styleUrls: ['./view-orders.component.css'],
  providers: [DatePipe]
})
export class ViewOrdersComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  toDayDateAndTime = new Date().toLocaleString();
  order: any ={};
  statesList: any;
  lines: any[] = [];
  shipLines: any[] = [];
  values: number = 0;
  showExp: boolean;
  address: Contacts = {};
  ohid: any;
  tabClicked = "order";
  sizeError: string;
  cityErrorMessage: string;
  size: string;
  packageInfo: any;
  orderHistoryActivities: any;
  pdfGenerate: string = 'N';
  needActionPopup: string = 'N';
  ReattemptRequestPopup: string = 'N';
  escalatePopup: string = 'N';
  actionInstructions: string;
  needActionReason: string;
  viewCustomer: any = {};
  addresses: any;
  citiesList: any;
  actionReasons: any = [];
  cancelActivities: string = 'N';
  orderActionPopup: string = 'N';
  cancelError: string;
  reason: string;
  cancelReasons: string;
  awbNumber: boolean = false;
  addressUpdate: boolean = false;
  shipmentDate: boolean = false;
  carrierName: boolean = false;
  receiverAdd: boolean = false;
  email: boolean = false;
  phone: boolean = false;
  trackingNumber: any;
  createdDate: string;
  receiverMobile: string;
  receiverEmail: string;
  //addressUpdate:string;
  updateAddress1: string = "";
  updateAddress2: string = "";
  updateCity: string = "";
  updateState: string = "";
  updateZip: string = "";
  shippingOption: string;
  Status: any;
  reasonDrop: string;
  editStatus: string;
  pickUpDate: string;
  delivered: string;
  reas
  shipmentCost: string;

  pickUPDateError: string;
  deliveryDate: string;
  reasonError: string;
  shipmentCostError: string;
  statusError: string;
  statusText4: string = '';
  statusText6: string = '';
  addressReceiver: string;
  arr: any[];

  constructor(private location: Location, private datePipe: DatePipe, private ngbModal: NgbModal, public activeModal: NgbActiveModal, private alertService: AlertService, private http: HttpClient, private route: ActivatedRoute, private g: Globals, private api: ApiIntegration, public user: User, private router: Router) {
    this.stateList();
    this.cityList();

    this.g.page = "View Orders";
    setInterval(() => {
      this.toDayDateAndTime = this.datePipe.transform(new Date(), 'dd-MM-yyyy HH:mm:ss');
    }, 1000);
    if (this.user.role == "ROLE_ADMIN") {
      this.viewAdmin();
    } else {
      this.viewPage();
    }
    //this.getAllAdminUsers();
    this.actionReasons = [
      { label: 'Contact information not appropriate', config: 'COMMUNICATION_INFO_ISSUE' },
      { label: 'Issue with Inventory', config: 'STOCK_ISSUE' }
    ];
  }

  goBack() {
    this.location.back();
  }

  openCarrierName() {
    this.carrierName = true;
  }

  closeCarrierName() {
    this.carrierName = false;
    this.shippingOption = "";
  }

  openAwbNumber() {
    this.awbNumber = true;
  }

  openPopup() {
    this.Status = 'Y';
  }

  closePopup() {
    this.Status = 'N';
  }

  updateStatus() {

    this.pickUPDateError = "";
    this.deliveryDate = "";
    this.reasonError = "";
    this.shipmentCostError = "";
    this.statusError = "";

    if (!this.editStatus) {
      this.statusError = "please select status";
      return false;
    }

    if (this.editStatus == 'IN_TRANSIT') {
      if (this.editStatus == 'IN_TRANSIT' && !this.pickUpDate) {
        this.pickUPDateError = "please select pickupDate";
        return false;
      }
    }

    if (this.editStatus == 'DELIVERED') {
      if (this.editStatus == 'DELIVERED' && !this.delivered) {
        this.deliveryDate = "please select deliveryDate";
        return false;
      }
    }

    if (this.editStatus == 'RETURN_TO_ORIGIN') {
      if (this.editStatus == 'RETURN_TO_ORIGIN' && !this.reason) {
        this.reasonError = "please enter reason"
      }

      if (this.editStatus == 'RETURN_TO_ORIGIN' && !this.shipmentCost) {
        this.shipmentCostError = "please enter reason"
      }

      if (this.reasonError || this.shipmentCostError) {
        return false;
      }
    }

    let convertPickUpDate = this.datePipe.transform(this.pickUpDate, 'yyyy/MM/dd');
    let convertDeliveredDate = this.datePipe.transform(this.delivered, 'yyyy/MM/dd');

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderProcessManually', {
      "accountOwnerId": this.order.accountOwnerId,
      "deliveryDate": convertDeliveredDate,
      "orderHeaderId": this.order.orderHeaderId,
      "orderStatus": this.editStatus,
      "organizationId": this.user.organizationId,
      "pickupDate": convertPickUpDate,
      "reason": this.reason,
      "shipmentCost": this.shipmentCost
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Status', 'Update Successfully');
          this.closePopup();
          this.clearStatus();
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.closepopUpRequest();
          this.alertService.error('Error', err);
        });
  }

  closeAwbNumber() {
    this.awbNumber = false;
    this.trackingNumber = "";
  }

  openShipment() {
    this.shipmentDate = true;
  }

  closeShipment() {
    this.shipmentDate = false;
    this.createdDate = "";
  }
  openMobileNumber() {
    this.phone = true;
  }

  closeMobileNumber() {
    this.phone = false;
    this.receiverMobile = "";
  }
  openGmail() {
    this.email = true;
  }

  closeGmail() {
    this.email = false;
    this.receiverEmail = "";
  }


  openPopupCancelActivities() {
    this.cancelActivities = 'Y';
    this.getReasons();
  }

  closepopUpRequest() {
    this.cancelActivities = 'N';
    this.cancelError = "";
  }

  openActionPopup() {
    this.orderActionPopup = 'Y';
  }

  closeOrderActionPopup() {
    this.orderActionPopup = 'N';
  }

  cancelOrder() {
    this.cancelError = "";
    if (!this.reason) {
      this.cancelError = 'please select reason';
      return false
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": this.order.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "CANCELLED",
      "organizationId": 1,
      "shippingOption": this.order.shippingOption,
      "accountOwnerId": this.order.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Cancelled Successfully');
          this.closepopUpRequest();
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.closepopUpRequest();
          this.alertService.error('Error', err);
        });
  }



  holdOrder() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": this.order.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "ON_HOLD",
      "organizationId": 1,
      "accountOwnerId": this.order.accountOwnerId,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Hold Successfully');
          this.closeOrderActionPopup();
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.closeOrderActionPopup();
          this.alertService.error('Error', err);
        });
  }

  getReasons() {
    this.api.getValues("1", 'OUTBOUND', 'CANCEL_REASON', 'Outbound Orders').subscribe((data: any) => {
      this.cancelReasons = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  needActionPopupOpen() {
    this.needActionPopup = 'Y';
  }

  closeNeedActionPopUp() {
    this.needActionPopup = 'N';
  }

  openEscalatePopup() {
    this.escalatePopup = 'Y';
  }

  closeEscalatePopup() {
    this.escalatePopup = 'N';
  }

  ReattemptRequestPopupOpen() {
    this.ReattemptRequestPopup = 'Y';
    this.viewCustomer = {
      "code": "200",
      "message": "Success",
      "role": null,
      "organizationId": 1,
      "id": 1,
      "accountType": "ACCOUNT_OWNER",
      "companyName": "Test123",
      "ownerName": "Sandeep",
      "mobile": 8904291446,
      "email": "sandeep@snithik.com",
      "status": "ACTIVE",
      "panCard": "NO",
      "panCardNumber": null,
      "aadharCard": "NO",
      "aadhartCardNumber": null,
      "mouDocument": "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList": [{
        "aoId": 1,
        "address1": "Test",
        "address2": "SuperMarket",
        "city": "Hyderabad",
        "state": "Telangana",
        "country": "",
        "addressType": "BILLING",
        "addressText": "Test, , Hyderabad, Telangana, 500089",
        "zip": "500089",
        "organizationId": 1,
        "addressId": 2,
        "geoCode": null
      }],
      "addressId": null,
      "createdBy": null,
      "createdDate": "26-09-2021",
      "updatedBy": null,
      "updatedDate": "08-10-2021",
      "expiryDate": "03-10-2021",
      "gstNumber": null
    }
  }

  closeReattemptRequestPopup() {
    this.ReattemptRequestPopup = 'N';
  }


  orderActivity() {
  }

  processOrder(order) {
    this.router.navigate(['/admin/orderProcessing/' + order.orderHeaderId]);
  }

  viewAdmin() {
    this.api.getOrderDataByAdminId(this.route.snapshot.params['id'], "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.addressReceiver = this.order.receiverAddressText;
      this.lines = this.order.lines;
      this.shipLines = this.order.shipLines;
      if ((this.order || {}).lines && (this.order || {}).lines.length) {
        this.showExp = (this.order || {}).lines[0].inStockStatus;
      }
      this.values = this.order.orderNumber;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }




  viewPage() {
    this.g.loaderDisplay = "display";
    this.api.getOrderDataById(this.route.snapshot.params['id'], this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.lines = this.order.lines;
      this.shipLines = this.order.shipLines;
      this.shipLines.forEach((s) => {
        s.packageWeight = s.numberOfBoxes * s.boxWeight;
      });
      if ((this.order || {}).lines && (this.order || {}).lines.length) {
        this.showExp = (this.order || {}).lines[0].inStockStatus;
      }
      this.values = this.order.orderNumber;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  printShipment(order) {
    console.log(this.ohid)

    // this.sizeError = "";

    /* if (!this.size) {
      this.sizeError = 'Please select size';
    }

    if (this.sizeError != "") {
      return false;
    }
 */
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generateShippingLabelPDF', {
      "headerId": this.order.orderHeaderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.order.accountOwnerId,
      "size": "A4"
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ib_' + this.order.orderHeaderId + '_shipping_label_' + "A4" + '_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pdfGenerate = 'N';
        this.viewPage();
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  generateShippingLabel(order) {
    if (order.thirdPartyShipLabelUrl !== null) {
      this.navigateShippingUrl(order);
    } else {
      this.printShipment(order);
    }
  }

  close() {
    this.pdfGenerate = 'N';
  }

  ngOnInit() {
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  tabChange(tab) {
    this.tabClicked = tab
    if (this.tabClicked == 'productDetails') {
      this.g.loaderDisplay = "display";
      this.api.getPackageInfoByOrderId(this.order.orderHeaderId, "ORDER").subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.packageInfo = data;
      }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    } else if (this.tabClicked == 'orderHistory') {
      this.g.loaderDisplay = "display";
      this.api.getOrderActivities(this.order.orderHeaderId, "ORDER", this.user.organizationId).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.orderHistoryActivities = data.ordersHistoryResponses;
      }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    }
  }

  generateManifest(order) {
    var headerInfo = new HttpHeaders();
    headerInfo = headerInfo.append('Content-Type', 'application/json');
    headerInfo = headerInfo.append('Accept', 'application/pdf');
    headerInfo = headerInfo.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateManifestPdfForOrders', {
      "accountOwnerId": this.user.accountOwnerId,
      "headerIds": [order.orderHeaderId],
      "organizationId": this.user.organizationId,
      "size": "A4"
    },
      { responseType: 'blob', headers: headerInfo }).subscribe((resp: any) => {
        this.g.loaderDisplay = "";
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'shipment_manifest_A4_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.alertService.success('Success', 'Manifest generated successfully');
        this.viewPage();
      }, err => {
        this.g.loaderDisplay = "";
        console.log(err);
        this.alertService.error('Error', err);
      });
  }

  navigateShippingUrl(order) {
    let j = 0;
    for (j = 0; j < order.thirdPartyShipLabelUrl.length; j++) {
      window.open(order.thirdPartyShipLabelUrl[j], '_blank')
    }
  }

  closeOpenFields() {
    this.awbNumber = false;
    this.shipmentDate = false;
    this.carrierName = false;
    this.email = false;
    this.phone = false;
  }

  openAddressText() {
    this.addressUpdate = true;
    this.arr = this.addressReceiver.split(',');
    this.updateAddress1 = this.arr[0];
    this.updateCity = this.arr[1];
    this.updateState = this.arr[2];
    this.updateZip = this.arr[3];
    console.log(this.arr[0]);
  }

  closeAddressText() {
    this.addressUpdate = false;
    this.updateAddress1 = '';
    this.updateAddress2 = '';
    this.updateCity = '';
    this.updateState = '';
    this.updateZip = '';
  }

  clearStatus() {
    this.pickUpDate = "";
    this.delivered = "";
    this.reason = "";
    this.shipmentCost = "";
    this.pickUPDateError = "";
    this.deliveryDate = "";
    this.reasonError = "";
    this.shipmentCostError = "";
    this.statusError = "";
  }

  editOrderData(ord) {

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderDetails', {
      "address1": this.order.deliveryAddress1,
      "address2": this.order.deliveryAddress2,
      "addressId": ord.addressId,
      "carrierCode": this.order.shippingOption,
      "city": this.order.deliveryCity,
      "contactId": ord.receiverId,
      "email": this.order.receiverEmail,
      "mobile": this.order.receiverMobile,
      "orderId": ord.orderHeaderId,
      "pincode": this.order.deliveryAreaPinCode,
      "state": this.order.deliveryState,
      "createdDate": this.order.createdDate,
      "trackingNumber": this.order.trackingNumbers

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.closeAddressText();
          this.closeOpenFields();
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.closeOpenFields();
        });
  }
  typeCity() {
    this.cityErrorMessage = "";
    if (this.updateCity == '' || this.updateCity === null || this.updateCity === undefined || this.updateCity === 'undefined') {
      this.cityErrorMessage = 'Please enter city';
    }
  }

  typeState() {
    this.statusText4 = "";
    if (this.updateState == '' || this.updateState === null || this.updateState === undefined || this.updateState === 'undefined') {
      this.statusText4 = 'Please enter state';
    }
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
    console.log(this.stateList);
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }


};
